import React, { ExoticComponent } from 'react'
import { Typography } from 'transfix-ui/core'
import uuid from 'uuid/v4'
import { CloseIcon } from 'transfix-icons'
import { useScrollLock } from 'utils/useScrollLock'
import 'scss/5_components/_dialog.scss'

const DIALOG = 'dialog'
const ACTIVE = 'active'
const OPEN_DIALOGS_SELECTOR = `.${DIALOG}.${ACTIVE}`

interface IDialogProps {
  children?: React.ReactNode
  header?: string
  size?: 'small' | 'medium' | 'full' | 'large'
  align?: 'right' | 'left' | 'bottom' | 'top'
  onClose?: Function
  closeDialog: Function
  dialogOpen?: boolean
  id?: string
  className?: string
  footer?: any
}

export const Dialog: ExoticComponent<IDialogProps> = React.memo(
  ({
    id = uuid(),
    header,
    footer,
    size = 'medium',
    align = 'top',
    children,
    closeDialog,
    onClose,
    dialogOpen = false,
    className = '',
  }) => {
    useScrollLock(dialogOpen, OPEN_DIALOGS_SELECTOR)

    const dialogClass = [
      DIALOG,
      size && `dialog-${size}`,
      align && `dialog-${align}`,
      dialogOpen && ACTIVE,
      className,
    ]
      .filter(x => x)
      .join(' ')
    const handleClose = () => closeDialog(onClose)

    return (
      <>
        <div role='dialog' className={dialogClass} data-test={`${id}-dialog`}>
          {header && (
            <div className='dialog-header'>
              <Typography variant='h2' className='heading' data-test='dialog-title'>
                {header}
              </Typography>
              <button
                aria-label='Close dialog'
                className='close btn-text-link tr'
                onClick={handleClose}
                data-test='dialog-close-button'>
                <CloseIcon />
              </button>
            </div>
          )}
          {children}
          {footer && <div className='dialog-footer'>{footer}</div>}
        </div>
        <div
          role='button'
          aria-label='Dismiss dialog'
          tabIndex={0}
          onKeyDown={handleClose}
          onClick={handleClose}
          data-test={`${id}-dialog-backdrop`}
          className={`dialog-backdrop ${dialogOpen ? 'active' : ''}`}
        />
      </>
    )
  }
)
